import React from 'react';

import MonthlySection from './MonthlySection';

export default function AnnualSection({ data }) {
    return <MonthlySection data={data} />;
}
